import React, { lazy, Suspense } from "react";
const HeadingsPanelController = lazy(
  () => import("./../toolbars-modals").then(({ HeadingsPanelController: HeadingsPanelController2 }) => ({
    default: HeadingsPanelController2
  }))
);
const HeadingPanelComponent = (suspenseWidth) => (props) => /* @__PURE__ */ React.createElement(Suspense, { fallback: /* @__PURE__ */ React.createElement("div", { style: { width: suspenseWidth } }) }, /* @__PURE__ */ React.createElement(HeadingsPanelController, { ...props }));
var HeadingsPanelComponent_default = HeadingPanelComponent;
export {
  HeadingsPanelComponent_default as default
};
//# sourceMappingURL=HeadingsPanelComponent.js.map
